import { render, staticRenderFns } from "./AccountsTab.vue?vue&type=template&id=4843f70c&scoped=true"
import script from "./AccountsTab.vue?vue&type=script&lang=ts"
export * from "./AccountsTab.vue?vue&type=script&lang=ts"
import style0 from "./AccountsTab.vue?vue&type=style&index=0&id=4843f70c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4843f70c",
  null
  
)

export default component.exports